<template>
	<div class="container p-0">
		<div :data-bs-theme="registration.venue?.resourceId || 'wewelcom'" class="card event-pass-card-root">
			<div class="card-header">
				<h3>
					<BadgeAccent> EVENTO</BadgeAccent>
					{{ registration.venue?.name }}
				</h3>
				<!-- Registration Type Badge (optional) -->
				<span v-if="showRegistrationType && registration.registrationType"
					class="registration-type-badge"
					:style="registrationTypeBadgeStyle">
					{{ registration.registrationType.name }}
				</span>
			</div>

			<div class="row g-0">
				<div class="col-lg-4 align-items-center h-100">
					<div class="info-inblock info-inblock-primary">
						<div>{{ formattedDate }}</div>
						<!--						<div class="vr-point"></div>
												<div>{{ formattedTime }}</div>-->
						<div class="vr-point"></div>
						<div>{{ totalAttendees }} Pers</div>
					</div>
					<div class="info-inblock info-inblock-black">
						<div class="info-reservation-name" data-bs-toggle="tooltip" data-bs-placement="top" :data-bs-title="invitedUsersString" type="button">
							{{ registration.event?.name }}
						</div>
					</div>
					<!--					<div class="info-inblock info-inblock-session">
											<i class="fas fa-ticket-alt me-2"></i>
											{{ registration.session?.name }}
										</div>-->

					<div class="hidden display-md">
						<ul class="list-group list-group-flush" style="border-radius: 0">
							<li class="list-group-item" v-if="isMacarfiVenue">
								<button class="btn btn-outline-primary w-100" @click="showInformationEventMacarfi = true">
									<i class="fas fa-info-circle me-1"></i> Información
								</button>
							</li>
							<li class="list-group-item">
								<!--							<div class="col-6">
																<button class="btn btn-outline-primary w-100" @click="showQRModal = true">
																	<i class="fas fa-qrcode me-1"></i> Ver QR
																</button>
															</div>-->
								<a v-if="googleMapsUrl" :href="googleMapsUrl" target="_blank" class="btn btn-outline-primary w-100">
									<i class="fas fa-map-marker-alt me-1"></i> Cómo llegar </a>
							</li>
						</ul>
					</div>
				</div>
				<div class="col-lg-8">
					<div class="card-body h-100 align-content-center" :style="headerStyle">
						<div v-if="false" class="schedule-session">
							<i class="fas fa-ticket-alt"></i>
							<span>{{ registration.session?.name }}</span>
						</div>
						<div class="row g-2">
							<div class="schedule-time-info col-md-6">
								<span class="schedule-time-label">Hora de inicio</span>
								<span class="schedule-time-value">{{ formattedTime }}</span>
							</div>
							<div v-if="false" class="schedule-time-info col-6">
								<span class="schedule-time-label">Llegada recomendada</span>
								<span class="schedule-time-value">{{ recommendedArrivalTime }}</span>
							</div>
							<div class="schedule-time-info col-md-6">
								<span class="schedule-time-label">Dirección</span>
								<span class="schedule-time-value">{{ addressText }}</span>
							</div>
						</div>

						<!-- Event Description -->
						<p v-if="registration.event?.description" class="card-text event-description">
							{{ registration.event.description }}
						</p>

						<!-- QR Code Section -->
						<div class="qr-section" v-if="false">
							<div class="qr-container" @click="showQRModal = true">
								<vue-qrcode :value="qrValue" :options="{ width: 150, margin: 1 }"></vue-qrcode>
								<p class="qr-label">Pulsa para ampliar</p>
							</div>
						</div>

						<!-- Status Badge -->
						<div v-if="false" class="status-badge-container">
							<span :class="['badge', statusBadgeClass]">
								<i :class="statusIcon"></i>
								{{ statusText }}
							</span>
						</div>

						<!-- Companions info -->
						<p v-if="registration.confirmedCompanions > 0" class="companions-text">
							<i class="fas fa-users me-1"></i>
							{{ registration.confirmedCompanions }} acompañante(s)
						</p>

						<!-- Directions info -->
						<div v-if="directionsText" class="directions-text">
							<i class="fas fa-info-circle me-1"></i>
							{{ directionsText }}
						</div>
					</div>
				</div>
			</div>

			<!-- Zone badge above buttons -->
			<div v-if="zoneDisplayName" class="event-zone-badge-wrapper">
				<span class="event-zone-label">Zona: </span>
				<span class="event-zone-badge" :style="zoneBadgeStyle">
					{{ zoneDisplayName }}
				</span>
			</div>

			<!-- Actions Footer -->
			<div class="card-footer hidden-md">
				<ul class="list-group list-group-flush" style="border-radius: 0">
					<li class="list-group-item">
						<div class="row row-column-gap g-2">
							<div class="col-6">
								<button v-if="isMacarfiVenue" class="btn btn-outline-primary w-100"
										@click="showInformationEventMacarfi = true">
									<i class="fas fa-info-circle me-1"></i> Información
								</button>
							</div>
							<div class="col-6">
								<a v-if="googleMapsUrl" :href="googleMapsUrl" target="_blank" class="btn btn-outline-primary w-100">
									<i class="fas fa-map-marker-alt me-1"></i> Cómo llegar </a>
							</div>
						</div>
					</li>
				</ul>
			</div>

			<AppFullscreenModal v-if="isMacarfiVenue" :is-visible="showInformationEventMacarfi" :close="true"
								@close="showInformationEventMacarfi = false" class="macarfi-modal">
				<template #header>
					<div class="macarfi-modal-header">
						<h5 class="macarfi-modal-title">Gala Premios Macarfi</h5>
					</div>
				</template>

				<div class="macarfi-presentation">
					<!-- Hero Section -->
					<div class="macarfi-hero-section">
						<div class="macarfi-hero-content">
							<!--						<div class="macarfi-hero-badge">-->
							<!--							<i class="fas fa-award"></i>-->
							<!--						</div>-->
							<!--						<h2 class="macarfi-hero-title border-bottom-0">XI Gala Premios</h2>-->
							<!--						<h1 class="macarfi-hero-brand">MACARFI</h1>-->
							<!--						<p class="macarfi-hero-tagline">Donde comen los que saben</p>-->
							<h2 class="macarfi-hero-title border-bottom-0">XI Gala Premios</h2>
							<div class="event-header-content-img">
								<img class="event-header-img" src="../../../public/img/LOGO_MACARFI_ALTA_2.jpg" alt=""/>
							</div>
							<p class="macarfi-hero-tagline">Donde comen los que saben</p>
						</div>
					</div>

					<!-- Section: ¿Qué es Macarfi? -->
					<section class="macarfi-section macarfi-section-intro">
						<div class="macarfi-section-icon">
							<i class="fas fa-utensils"></i>
						</div>
						<h3 class="macarfi-section-title">¿Qué es Macarfi?</h3>
						<p>Es una
							<strong>
								una guía de restaurantes de Cataluña, Comunidad de Madrid, País Vasco, La Rioja, Comunidad Valenciana, Andalucía, Cantabria y Principado de Asturias.
							</strong> Que en la edición de la Guía 2026, que presentaremos durante la gala, completaremos la guía a nivel peninsular, con la incorporación de
							<em>Galicia, Aragón, Castilla-La Mancha, Castilla y León, Extremadura,
								Navarra y Murcia</em>.</p>
						<p>El proyecto Macarfi fue iniciado por
							<strong>Manuel Carreras Fisas</strong>, presidente y fundador, quien publicó la primera edición de la Guía Macarfi en octubre de 2015.
						</p>
						<div class="macarfi-highlight-box">
							<span class="macarfi-highlight-number">11</span>
							<span class="macarfi-highlight-text">años de rigor, independencia y pasión nos han permitido decodificar el

ADN culinario de cada región.</span>
						</div>
					</section>

					<!-- Section: La Gala -->
					<section class="macarfi-section macarfi-section-gala">
						<div class="macarfi-section-icon">
							<i class="fas fa-gem"></i>
						</div>
						<h3 class="macarfi-section-title">La Gala</h3>
						<p>La XI Gala Macarfi no es solo una entrega de premios; es el
							<strong>epicentro donde converge el mapa culinario nacional</strong>.</p>
						<p>
							Este año, la <strong>Comunidad de Madrid</strong> se viste de gala para acoger a
							los <strong>mejores chefs de la península</strong>.
						</p>
						<!--						<div class="macarfi-stats-row">
													<div class="macarfi-stat">
														<span class="macarfi-stat-number">150</span>
														<span class="macarfi-stat-label">Mejores chefs</span>
													</div>
													<div class="macarfi-stat">
														<span class="macarfi-stat-number">17</span>
														<span class="macarfi-stat-label">Comunidades</span>
													</div>
													<div class="macarfi-stat">
														<span class="macarfi-stat-number">1</span>
														<span class="macarfi-stat-label">Noche única</span>
													</div>
												</div>-->
						<blockquote class="macarfi-blockquote">
							<i class="fas fa-quote-left"></i>
							Es la cita imprescindible para los protagonistas del sector y una celebración de
							la excelencia que une a toda nuestra geografía bajo un mismo criterio: la

							calidad sin concesiones.
						</blockquote>
					</section>

					<!-- Section: Premios -->
					<section class="macarfi-section macarfi-section-awards">
						<div class="macarfi-section-icon">
							<i class="fas fa-trophy"></i>
						</div>
						<h3 class="macarfi-section-title">Premios 2026</h3>
						<p>En Macarfi creemos que la gastronomía se vive de muchas formas. Por ello, nuestra guía premia
						</p>
						<div class="macarfi-awards-grid">
							<div class="macarfi-award-card macarfi-award-gold">
								<i class="fas fa-crown"></i>
								<span class="macarfi-award-name">Top of the Tops</span>
								<span class="macarfi-award-desc">categoría especial fuera del ranking por haber sido número 1 durante 3 años
consecutivos</span>
							</div>
							<div class="macarfi-award-card macarfi-award-silver">
								<i class="fas fa-medal"></i>
								<span class="macarfi-award-name">Top 10/15 Comunidades Autónomas</span>
								<span class="macarfi-award-desc">Los mejores de cada región</span>
							</div>
							<div class="macarfi-award-card macarfi-award-bronze">
								<i class="fas fa-rocket"></i>
								<span class="macarfi-award-name">Rookies 2026</span>
								<span class="macarfi-award-desc">Las mejores aperturas del año</span>
							</div>
						</div>
					</section>

					<!-- Section: Embajadores -->
					<section class="macarfi-section macarfi-section-ambassadors">
						<div class="macarfi-section-icon">
							<i class="fas fa-users"></i>
						</div>
						<h3 class="macarfi-section-title">Embajadores</h3>

						<p>Esta guía tiene la particularidad de que está alimentada por gente corriente, personas a las que sencillamente les apasiona el buen comer y que comparten sus críticas y puntuaciones de los restaurantes que visitan de forma desinteresada y anónima.</p>
						<div class="macarfi-feature-box">
							<i class="fas fa-shield-alt"></i>
							<p>El Ranking Top Macarfi se elabora a partir de las opiniones y puntuaciones de nuestros embajadores y la ayuda de una comunidad de gourmets.</p>
						</div>
					</section>

					<!-- Section: Metodología -->
					<section class="macarfi-section macarfi-section-methodology">
						<div class="macarfi-section-icon">
							<i class="fas fa-chart-line"></i>
						</div>
						<h3 class="macarfi-section-title">Metodología</h3>
						<p>Cada restaurante es puntuado de 0 a 10 por los siguientes criterios:</p>
						<div class="macarfi-criteria-grid">
							<div class="macarfi-criterion-card">
								<div class="macarfi-criterion-icon">
									<i class="fa-solid fa-utensils"></i>
								</div>
								<h4>Comida</h4>
							</div>
							<div class="macarfi-criterion-card">
								<div class="macarfi-criterion-icon">
									<i class="fa-solid fa-wine-glass"></i>
								</div>
								<h4>Decoración</h4>
							</div>
							<div class="macarfi-criterion-card">
								<div class="macarfi-criterion-icon">
									<i class="fas fa-concierge-bell"></i>
								</div>
								<h4>Servicio</h4>
							</div>
						</div>
					</section>

					<!-- Footer Quote -->
					<div class="macarfi-footer-section">
						<div class="macarfi-footer-quote">
							<span class="macarfi-quote-marks">"</span>
							<p>Donde comen los que saben no es un slogan, es nuestra metodología de trabajo.</p>
						</div>
						<div class="macarfi-footer-logo">
							<span class="macarfi-logo-text">MACARFI</span>
							<span class="macarfi-logo-year">2026</span>
						</div>
					</div>
				</div>

				<template #footer>
					<AccentButton @click="showInformationEventMacarfi = false"> Cerrar</AccentButton>
				</template>
			</AppFullscreenModal>

		</div>
		<!-- QR Modal -->
		<div v-if="showQRModal" class="qr-modal-overlay" @click="showQRModal = false">
			<div class="qr-modal-content" @click.stop>
				<button class="qr-modal-close" @click="showQRModal = false">
					<i class="fas fa-times"></i>
				</button>
				<h4>{{ registration.event?.name }}</h4>
				<p class="qr-modal-session">{{ registration.session?.name }}</p>
				<div class="qr-modal-code">
					<vue-qrcode :value="qrValue" :options="{ width: 280, margin: 2 }"></vue-qrcode>
				</div>
				<p class="qr-modal-instructions">Muestra este código QR en la entrada del evento</p>
			</div>
		</div>

	</div>
</template>

<script setup>
import {computed, ref} from "vue";
import VueQrcode from "vue-qrcode";
import BadgeAccent from "@/components/ui/Badges/variants/BadgeAccent.vue";
import AppFullscreenModal from "@/components/ui/modals/AppFullscreenModal.vue";
import AccentButton from "@/components/ui/buttons/variants/AccentButton.vue";


const props = defineProps({
	registration: {
		type: Object,
		required: true,
	},
	showRegistrationType: {
		type: Boolean,
		default: false,
	},
});

const showQRModal = ref(false);
const showInformationEventMacarfi = ref(false);

// Computed values
const formattedDate = computed(() => {
	if (!props.registration.session?.businessDate) return "";

	const date = new Date(props.registration.session.businessDate);
	const options = {weekday: "short", day: "numeric", month: "short"};
	return date.toLocaleDateString("es-ES", options);
});

const formattedTime = computed(() => {
	if (!props.registration.session?.startsAt) return "";

	const date = new Date(props.registration.session.startsAt);
	return date.toLocaleTimeString("es-ES", {hour: "2-digit", minute: "2-digit"}) + " h";
});

// Hora recomendada de llegada (30 minutos antes del inicio)
const recommendedArrivalTime = computed(() => {
	if (!props.registration.session?.startsAt) return "";

	const startDate = new Date(props.registration.session.startsAt);
	const arrivalDate = new Date(startDate.getTime() - 30 * 60 * 1000); // 30 min antes
	return arrivalDate.toLocaleTimeString("es-ES", {hour: "2-digit", minute: "2-digit"}) + " h";
});

const totalAttendees = computed(() => props.registration.totalAttendees || 1);

// Use userHostCode for QR - identifies the user across all their registrations
// Hosts scan this QR to find the user and check their registrations
const qrValue = computed(() => props.registration.userHostCode || "");

const statusText = computed(() => {
	const statusMap = {
		pending: "Pendiente",
		confirmed: "Confirmado",
		attended: "Asistido",
		cancelled: "Cancelado",
	};
	return statusMap[props.registration.status] || "Confirmado";
});

const statusBadgeClass = computed(() => {
	const classMap = {
		pending: "bg-warning text-dark",
		confirmed: "bg-success",
		attended: "bg-info",
		cancelled: "bg-danger",
	};
	return classMap[props.registration.status] || "bg-success";
});

const statusIcon = computed(() => {
	const iconMap = {
		pending: "fas fa-clock",
		confirmed: "fas fa-check-circle",
		attended: "fas fa-check-double",
		cancelled: "fas fa-times-circle",
	};
	return iconMap[props.registration.status] || "fas fa-check-circle";
});

const googleMapsUrl = computed(() => {
	const location = props.registration.location;

	// Use pre-computed Google Maps URL if available (most accurate)
	if (location?.googleMapsUrl) {
		return location.googleMapsUrl;
	}

	// If coordinates available, use them
	if (location?.hasCoordinates && location?.latitude && location?.longitude) {
		return `https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}`;
	}

	// Use full or short address
	if (location?.fullAddress) {
		return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location.fullAddress)}`;
	}
	if (location?.address && location?.city) {
		const query = encodeURIComponent(`${location.address}, ${location.city}`);
		return `https://www.google.com/maps/search/?api=1&query=${query}`;
	}

	// Fallback: use venue name
	const venue = props.registration.venue;
	if (venue?.name) {
		return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(venue.name)}`;
	}
	return null;
});

// Get directions text if available
const directionsText = computed(() => props.registration.location?.directions || null);
// Get directions text if available
const addressText = computed(() => props.registration.location?.address || null);

// Check if venue is Macarfi (case insensitive)
const isMacarfiVenue = computed(() => {
	const venueName = props.registration.venue?.subdomain?.toLowerCase();
	return venueName === "macarfi";
});


const headerStyle = computed(() => {
	const imageRestaurant = props.registration.venue?.resourceId;

	return {
		backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.667)), url('${window.location.href}/world/img/${imageRestaurant}/header/header.jpg')`,
		backgroundSize: "cover",
		backgroundPosition: "center",
		backgroundRepeat: "no-repeat",
	};
});

// Registration type badge style
const registrationTypeBadgeStyle = computed(() => {
	const badgeColor = props.registration.registrationType?.badgeColor || "#6c757d";
	return {
		backgroundColor: badgeColor,
		color: "#ffffff",
	};
});

// Zone only: show badge when zoneName is present. No badge if zone is null or empty.
const zoneDisplayName = computed(() => {
	const name = props.registration.zoneName;
	return name != null && String(name).trim() !== "" ? String(name).trim() : null;
});

// Zone badge style (color from backend or neutral fallback). Guard against null/empty zoneColor.
const zoneBadgeStyle = computed(() => {
	const raw = props.registration.zoneColor;
	const color = raw != null && String(raw).trim() !== "" ? String(raw).trim() : "#6c757d";
	return {
		backgroundColor: color,
		color: "#ffffff",
	};
});
</script>

<style scoped lang="scss">
/* Allow page scroll when pointer/touch is over the card (match welcom-front fix) */
.event-pass-card-root {
	touch-action: pan-x pan-y;
	overscroll-behavior-y: auto;

	.card-header,
	.card-body,
	.card-footer,
	.row {
		touch-action: pan-x pan-y;
		overscroll-behavior-y: auto;
	}
}

.event-pass-container {
	margin-bottom: 1rem;
}

.event-pass-card {
	border: none;
	border-radius: 12px;
	overflow: hidden;
	box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.event-header {
	background: var(--app-accent);
	color: var(--app-accent-color);
	padding: 1rem 1.25rem;
	position: relative;
}

.event-header h3 {
	margin: 0;
	font-size: 1.1rem;
	font-weight: 600;
}

.event-badge {
	display: inline-flex;
	align-items: center;
	gap: 0.25rem;
	font-size: 0.65rem;
	font-weight: 700;
	letter-spacing: 0.05em;
	background: rgba(255, 255, 255, 0.2);
	padding: 0.2rem 0.5rem;
	border-radius: 4px;
	margin-bottom: 0.5rem;
}

.registration-type-badge {
	display: inline-block;
	font-size: 0.75rem;
	font-weight: 600;
	padding: 0.35rem 0.75rem;
	border-radius: 20px;
	margin-top: 0.5rem;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.event-zone-badge-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 0.5rem;
	padding: 0.75rem 1rem;
}

.event-zone-label {
	font-size: 0.8rem;
	font-weight: 600;
	color: inherit;
}

.event-zone-badge {
	display: inline-block;
	font-size: 0.8rem;
	font-weight: 600;
	padding: 0.4rem 1rem;
	border-radius: 20px;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

/*
.info-inblock {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	gap: 0.5rem;
	padding: 0.75rem 1rem;
}

.info-inblock-primary {
	background-color: #e8f0fe;
	color: #1e3a8a;
	font-weight: 500;
}

.info-inblock-black {
	background-color: #1a1a2e;
	color: white;
}

.info-inblock-session {
	background-color: #f0f0f0;
	color: #555;
	font-size: 0.9rem;
}*/
//
//.info-event-name {
//	font-weight: 600;
//	font-size: 1rem;
//}
//
//.vr-point {
//	width: 4px;
//	height: 4px;
//	border-radius: 50%;
//	background-color: currentColor;
//	opacity: 0.5;
//}
//
//.card-body {
//	padding: 1.25rem;
//}
.info-inblock-session {
	align-items: center;
	background-color: #f0f0f0;
	color: #555;
	font-size: 0.9rem;
}

.card-body[style*="background-image"] {
	min-height: 200px;
	color: white;

	.event-description {
		color: rgba(255, 255, 255, 0.9);
	}

	.companions-text {
		color: rgba(255, 255, 255, 0.85);
	}

	.directions-text {
		background-color: rgba(255, 255, 255, 0.15);
		color: rgba(255, 255, 255, 0.9);
	}

	.status-badge-container .badge {
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
	}
}

/* Event Schedule Card - Glassmorphism style */
.event-schedule-card {
	background: rgba(255, 255, 255, 0.12);
	backdrop-filter: blur(10px);
	-webkit-backdrop-filter: blur(10px);
	border: 1px solid rgba(255, 255, 255, 0.15);
	border-radius: 12px;
	padding: 1rem;
	margin-bottom: 1rem;
}

.schedule-session {
	font-size: 1.1rem;
	margin-bottom: .25rem;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 0.25rem;
}

.schedule-times {
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
}

@media (min-width: 576px) {
	.schedule-times {
		flex-direction: row;
		justify-content: space-around;
	}
}

.schedule-time-item {
	display: flex;
	align-items: center;
	gap: 0.75rem;
}

.schedule-time-icon {
	width: 40px;
	height: 40px;
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.schedule-time-icon i {
	font-size: 1rem;
}

.schedule-time-start {
	background: rgba(40, 167, 69, 0.25);
	color: #5dd879;
}

.schedule-time-arrival {
	background: rgba(255, 193, 7, 0.25);
	color: #ffc107;
}

.schedule-time-info {
	display: flex;
	flex-direction: column;
}

.schedule-time-label {
	font-size: 1rem;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	//color: rgba(255, 255, 255, 0.6);
}

.schedule-time-value {
	font-size: 1.5rem;
	font-weight: 700;
	//color: #fff;
}

.schedule-time-recommended {
	position: relative;
}

.schedule-time-recommended::before {
	content: "¡Llega a tiempo!";
	position: absolute;
	top: -8px;
	right: 0;
	font-size: 0.6rem;
	background: linear-gradient(135deg, #ffc107, #ff9800);
	color: #1a1a2e;
	padding: 0.15rem 0.4rem;
	border-radius: 4px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.03em;
}

@media (min-width: 576px) {
	.schedule-time-recommended::before {
		top: -10px;
		right: auto;
		left: 50%;
		transform: translateX(-50%);
	}
}

.event-description {
	color: #666;
	font-size: 1rem;
	margin-bottom: 1rem;
	line-height: 1.5;
}

.qr-section {
	display: flex;
	justify-content: center;
	margin: 1rem 0;
}

.qr-container {
	text-align: center;
	cursor: pointer;
	padding: 0.5rem;
	border-radius: 8px;
	transition: background-color 0.2s;
}

.qr-container:hover {
	background-color: #f5f5f5;
}

.qr-label {
	font-size: 0.75rem;
	color: #888;
	margin-top: 0.5rem;
	margin-bottom: 0;
}

.status-badge-container {
	text-align: center;
	margin: 0.75rem 0;
}

.status-badge-container .badge {
	font-size: 0.85rem;
	padding: 0.5rem 1rem;
	border-radius: 20px;
}

.companions-text {
	text-align: center;
	color: #666;
	font-size: 0.9rem;
	margin-bottom: 0;
}

.directions-text {
	text-align: center;
	color: #888;
	font-size: 0.85rem;
	margin-top: 0.75rem;
	padding: 0.5rem;
	background-color: #f8f9fa;
	border-radius: 6px;
	font-style: italic;
}

.card-footer {
	background-color: transparent;
	border-top: 1px solid #f0f0f0;
	padding: 0;
}

.list-group-item {
	border: none;
	padding: 0.75rem 1rem;
}

/* QR Modal */
.qr-modal-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.8);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
	padding: 1rem;
}

.qr-modal-content {
	background: white;
	border-radius: 16px;
	padding: 2rem;
	text-align: center;
	max-width: 350px;
	width: 100%;
	position: relative;
}

.qr-modal-close {
	position: absolute;
	top: 1rem;
	right: 1rem;
	background: none;
	border: none;
	font-size: 1.25rem;
	color: #666;
	cursor: pointer;
}

.qr-modal-content h4 {
	margin: 0 0 0.25rem;
	color: #333;
	font-weight: 600;
}

.qr-modal-session {
	color: #666;
	font-size: 0.9rem;
	margin-bottom: 1.5rem;
}

.qr-modal-code {
	display: flex;
	justify-content: center;
	margin-bottom: 1rem;
}

.qr-modal-instructions {
	color: #888;
	font-size: 0.85rem;
	margin-bottom: 0;
}

/*!* Responsive *!
@media (max-width: 576px) {
	.info-inblock {
		font-size: 0.9rem;
	}
}*/

/* Modal Header Custom */
.macarfi-modal-header {
	display: flex;
	align-items: center;
	gap: 0.25rem;
}

.macarfi-edition-badge {
	font-size: 0.65rem;
	font-weight: 700;
	letter-spacing: 0.15em;
	color: var(--app-accent);
	background: rgba(212, 175, 55, 0.15);
	padding: 0.2rem 0.6rem;
	border-radius: 4px;
}

.macarfi-modal-title {
	margin: 0;
	font-size: 1.1rem;
	font-weight: 600;
}

/* Main Presentation Container */
.macarfi-presentation {
	max-width: 100%;
	line-height: 1.6;
	//background: radial-gradient(ellipse at top, #1a1a2e 0%, #0d0d1a 100%);
}

/* Hero Section */
.macarfi-hero-section {
	text-align: center;
	padding: 2.5rem 1rem;
	//background: linear-gradient(180deg, rgba(212, 175, 55, 0.1) 0%, transparent 100%);
	border-bottom: 1px solid rgba(var(--app-accent-rgb), 0.2);
	margin-bottom: 1.5rem;
	display: grid;
	place-content: center;
}

.macarfi-hero-content {
	max-width: 400px;
	margin: 0 auto;

}

.macarfi-hero-badge {
	width: 60px;
	height: 60px;
	margin: 0 auto 1rem;
	background: linear-gradient(135deg, var(--app-accent) 0%, var(--app-accent) 50%, var(--app-primary) 100%);
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 4px 20px rgba(var(--app-accent-rgb) 0.4);
}

.macarfi-hero-badge i {
	font-size: 1.5rem;
	color: var(--app-primary);
}

.macarfi-hero-title {
	font-size: 0.9rem;
	font-weight: 400;
	letter-spacing: 0.2em;
	text-transform: uppercase;
	color: rgba(255, 255, 255, 0.7);
	margin-bottom: 0.25rem;
}

.macarfi-hero-brand {
	font-size: 2.5rem;
	font-weight: 800;
	letter-spacing: 0.1em;
	color: #fff;
	margin-bottom: 0.5rem;
	text-shadow: 0 2px 20px rgba(212, 175, 55, 0.3);
}

.macarfi-hero-tagline {
	font-size: 0.85rem;
	font-style: italic;
	color: var(--app-accent);
	margin: 0;
}

/* Glass Card - Event Info */
.macarfi-info-glass {
	background: rgb(255, 255, 255);
	backdrop-filter: blur(10px);
	-webkit-backdrop-filter: blur(10px);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 16px;
	padding: 1.25rem;
	margin-bottom: 1.5rem;
	display: flex;
	flex-direction: column;
	gap: 1rem;
}

.macarfi-info-item {
	display: flex;
	align-items: center;
	gap: 1rem;
}

.macarfi-info-icon {
	width: 40px;
	height: 40px;
	background: rgba(var(--app-accent-rgb), 0.2);
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.macarfi-info-icon i {
	color: var(--app-accent);
	font-size: 1rem;
}

.macarfi-info-text {
	display: flex;
	flex-direction: column;
}

.macarfi-info-label {
	font-size: 0.7rem;
	text-transform: uppercase;
	letter-spacing: 0.1em;
	color: rgba(255, 255, 255, 0.5);
}

.macarfi-info-value {
	font-size: 0.95rem;
	font-weight: 600;
	color: #fff;
}

.macarfi-info-divider {
	height: 1px;
	background: linear-gradient(90deg, transparent, rgba(212, 175, 55, 0.3), transparent);
}

/* Section Base Styles */
.macarfi-section {
	background: rgba(255, 255, 255);
	border-radius: 16px;
	padding: 1.5rem;
	margin-bottom: 1rem;
	position: relative;
	overflow: hidden;
	color: black;
}

.macarfi-section::before {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	height: 3px;
	background: var(--app-accent);
}

.macarfi-section-icon {
	width: 50px;
	height: 50px;
	background: rgba(var(--app-primary-rgb), 100%);
	border: 1px solid rgba(var(--app-primary-rgb), 0.3);
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 1rem;
	color: var(--app-accent);
}

.macarfi-section-icon i {
	font-size: 1.25rem;
}

.macarfi-section-title {
	font-size: 1.25rem;
	font-weight: 700;
	color: #000;
	margin-bottom: 1rem;
}

.macarfi-section p {
	color: rgba(0, 0, 0, 0.8);
	font-size: 1rem;
	margin-bottom: 0.75rem;
	line-height: 1.7;
}

.macarfi-section p:last-child {
	margin-bottom: 0;
}

.macarfi-section strong {
	color: var(--app-primary);
}

.macarfi-section em {
	color: rgba(var(--app-primary-rgb), 0.95);
}

/* Highlight Box */
.macarfi-highlight-box {
	display: flex;
	align-items: center;
	gap: 1rem;
	background: rgba(var(--app-primary-rgb), 100%);
	border-left: 3px solid var(--app-accent);
	padding: 1rem;
	border-radius: 0 10px 10px 0;
	margin-top: 1rem;
}

.macarfi-highlight-number {
	font-size: 2.5rem;
	font-weight: 800;
	color: var(--app-accent);
	line-height: 1;
}

.macarfi-highlight-text {
	font-size: 1rem;
	color: rgba(255, 255, 255, 0.8);
	line-height: 1.4;
}

/* Stats Row */
.macarfi-stats-row {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 0.75rem;
	margin: 1.25rem 0;
}

.macarfi-stat {
	text-align: center;
	padding: 1rem 0.5rem;
	background: rgba(255, 255, 255, 0.05);
	border-radius: 10px;
}

.macarfi-stat-number {
	display: block;
	font-size: 1.75rem;
	font-weight: 800;
	color: var(--app-primary);
	line-height: 1;
}

.macarfi-stat-label {
	display: block;
	font-size: 0.7rem;
	color: rgba(0, 0, 0, 0.6);
	text-transform: uppercase;
	letter-spacing: 0.05em;
	margin-top: 0.25rem;
}

/* Blockquote */
.macarfi-blockquote {
	position: relative;
	background: rgba(var(--app-primary-rgb), 100%);
	border-radius: 12px;
	padding: 1.25rem;
	padding-left: 3rem;
	margin: 1rem 0 0 0;
	font-style: italic;
	color: rgba(255, 255, 255, 0.9);
	font-size: 0.9rem;
	line-height: 1.6;
}

.macarfi-blockquote i {
	position: absolute;
	left: 1rem;
	top: 1rem;
	color: var(--app-accent);
	font-size: 1.25rem;
	opacity: 0.6;
}

/* Awards Grid */
.macarfi-awards-grid {
	display: grid;
	gap: 0.75rem;
	margin-top: 1rem;
}

.macarfi-award-card {
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	padding: 1.25rem 1rem;
	border-radius: 12px;
	background: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	transition: transform 0.2s, box-shadow 0.2s;
}

.macarfi-award-card i {
	font-size: 1.5rem;
	margin-bottom: 0.5rem;
}

.macarfi-award-name {
	font-size: 0.95rem;
	font-weight: 700;
	color: #000;
	margin-bottom: 0.25rem;
}

.macarfi-award-desc {
	font-size: 0.75rem;
	//color: rgba(255, 255, 255, 0.6);
}

.macarfi-award-gold {
	background: linear-gradient(135deg, rgba(212, 175, 55, 0.2) 0%, rgba(212, 175, 55, 0.05) 100%);
	border-color: rgba(212, 175, 55, 0.4);
	color: #d4af37;
}

.macarfi-award-silver {
	background: linear-gradient(135deg, rgba(192, 192, 192, 0.15) 0%, rgba(192, 192, 192, 0.05) 100%);
	border-color: rgba(192, 192, 192, 0.3);
	color: #c0c0c0;
}

.macarfi-award-bronze {
	background: linear-gradient(135deg, rgba(205, 127, 50, 0.15) 0%, rgba(205, 127, 50, 0.05) 100%);
	border-color: rgba(205, 127, 50, 0.3);
	color: #cd7f32;
}

/* Ambassador Section */
.macarfi-ambassador-stat {
	text-align: center;
	margin-bottom: 1rem;
}

.macarfi-big-number {
	display: block;
	font-size: 3rem;
	font-weight: 800;
	background: linear-gradient(135deg, var(--app-primary) 0%, var(--app-primary) 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
	line-height: 1;
}

.macarfi-big-label {
	display: block;
	font-size: 0.8rem;
	color: rgba(255, 255, 255, 0.6);
	text-transform: uppercase;
	letter-spacing: 0.1em;
	margin-top: 0.25rem;
}

.macarfi-feature-box {
	display: flex;
	align-items: flex-start;
	gap: 1rem;
	background: rgba(var(--app-primary-rgb), 100%);
	border-radius: 12px;
	padding: 1rem;
	margin-top: 1rem;
}

.macarfi-feature-box i {
	color: var(--app-accent);
	font-size: 1.25rem;
	margin-top: 0.15rem;
}

.macarfi-feature-box p {
	margin: 0;
	font-size: 0.85rem;
	color: rgba(255, 255, 255, 0.8);
}

/* Criteria Grid */
.macarfi-criteria-grid {
	display: grid;
	gap: 0.75rem;
	margin: 1rem 0;
}

.macarfi-criterion-card {
	text-align: center;
	padding: 1.25rem 1rem;
	background: rgba(255, 255, 255, 0.05);
	border-radius: 12px;
	border: 1px solid rgba(255, 255, 255, 0.08);
}

.macarfi-criterion-icon {
	width: 50px;
	height: 50px;
	margin: 0 auto 0.75rem;
	background: var(--app-primary);
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.macarfi-criterion-icon i {
	font-size: 1.25rem;
	color: var(--app-accent);
}

.macarfi-criterion-card h4 {
	font-size: 0.95rem;
	font-weight: 700;
	color: #000;
	margin: 0 0 0.25rem 0;
}

.macarfi-criterion-card p {
	font-size: 0.8rem;
	color: rgba(var(--app-primary-rgb), 0.6);
	margin: 0;
}

.macarfi-process-note {
	display: flex;
	align-items: flex-start;
	gap: 0.75rem;
	background: rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	padding: 1rem;
	margin-top: 1rem;
}

.macarfi-process-note i {
	color: var(--app-primary);
	font-size: 1.1rem;
	margin-top: 0.1rem;
}

.macarfi-process-note p {
	margin: 0;
	font-size: 0.85rem;
}

/* Footer Section */
.macarfi-footer-section {
	margin-top: 1.5rem;
	padding-top: 1.5rem;
	border-top: 1px solid rgba(212, 175, 55, 0.2);
}

.macarfi-footer-quote {
	text-align: center;
	margin-bottom: 1.5rem;
}

.macarfi-quote-marks {
	display: block;
	font-size: 3rem;
	line-height: 1;
	color: var(--app-accent);
	opacity: 0.5;
	font-family: Georgia, serif;
}

.macarfi-footer-quote p {
	font-size: 1.1rem;
	font-style: italic;
	font-weight: 500;
	color: rgba(255, 255, 255, 0.9);
	margin: 0;
	line-height: 1.5;
}

.macarfi-footer-logo {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.25rem;
	opacity: 0.6;
}

.macarfi-logo-text {
	font-size: 1.5rem;
	font-weight: 800;
	letter-spacing: 0.15em;
	color: var(--app-accent);
}

.macarfi-logo-year {
	font-size: 0.75rem;
	letter-spacing: 0.3em;
	color: rgba(255, 255, 255, 0.5);
}

.event-header-content-img {
	max-width: 200px;
}

.event-header-img {
	max-width: 100%;
	max-height: 100%;
	height: auto;
	width: auto;
	border-radius: 15px;
}

/* Responsive Styles */
@media (min-width: 576px) {
	.macarfi-info-glass {
		flex-direction: row;
		justify-content: space-around;
		align-items: center;
	}

	.macarfi-info-divider {
		width: 1px;
		height: 40px;
		background: linear-gradient(180deg, transparent, rgba(212, 175, 55, 0.3), transparent);
	}

	.macarfi-info-item {
		flex-direction: column;
		text-align: center;
		gap: 0.5rem;
	}

	.macarfi-info-text {
		align-items: center;
	}

	.macarfi-awards-grid {
		grid-template-columns: repeat(3, 1fr);
	}

	.macarfi-criteria-grid {
		grid-template-columns: repeat(3, 1fr);
	}

	.macarfi-hero-brand {
		font-size: 3rem;
	}

}
</style>
